import { useResolvedPath } from 'react-router-dom';

//* This hook returns the resolved path for the order details route */

export function useOrderDetailsRoute(): string {
  return useResolvedPath('.').pathname.split('/').slice(0, -1).join('/');
}
